import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

const StyledSmall = styled.small`
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const Ellipsis = ({
  value = '',
  initialShowMore = false,
  maxLength = 100
}) => {
  const [showMore, setShowMore] = useState(initialShowMore);

  const canExpand = useMemo(() => value.length > maxLength, [value, maxLength]);

  return (
    <span>
      {canExpand && !showMore ? `${value.slice(0, maxLength)}...` : value}{' '}
      {canExpand && (
        <StyledSmall onClick={() => setShowMore(prev => !prev)}>
          {showMore ? 'Ver Menos' : 'Ver Mais'}
        </StyledSmall>
      )}
    </span>
  );
};
